import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AppContext } from "context";

const wifiBars = [
    { d: "M12 19.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z", delay: 0 },
    { d: "M5.64 16.36a8.97 8.97 0 0112.73 0", delay: 0.3 },
    { d: "M2.1 12.82a13.44 13.44 0 0119.8 0", delay: 0.6 },
];

const DiscardReconnectionOverlay = () => {
    const { isConnected } = React.useContext(AppContext);

    if(isConnected) {
        return null;
    }

    return (
        <AnimatePresence mode="wait">
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.25 }}
                className="absolute z-[25] w-full h-full rounded-full bg-black/70 flex flex-col items-center justify-center gap-2"
            >
                <svg viewBox="0 0 24 24" fill="none" className="w-10 h-10">
                    {wifiBars.map((bar, i) => (
                        <motion.path
                            key={i}
                            d={bar.d}
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            fill={i === 0 ? "white" : "none"}
                            initial={{ opacity: 0.2 }}
                            animate={{ opacity: [0.2, 1, 0.2] }}
                            transition={{
                                duration: 1.5,
                                repeat: Infinity,
                                delay: bar.delay,
                                ease: "easeInOut",
                            }}
                        />
                    ))}
                </svg>
                <span className="text-white/80 text-xs font-medium">Reconnexion...</span>
            </motion.div>
        </AnimatePresence>
    );
};

export default DiscardReconnectionOverlay;
